import {
  FETCH_DELETE_USER_BY_USER_ID_REQUEST,
  FETCH_DELETE_USER_BY_USER_ID_SUCCESS,
  FETCH_DELETE_USER_BY_USER_ID_FALUIRE,
} from './deleteUserByUserIDTypes'

const initialState = {
  loading: false,
  isDeleteUserSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELETE_USER_BY_USER_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_USER_BY_USER_ID_SUCCESS : return {
      ...state,
      isDeleteUserSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_USER_BY_USER_ID_FALUIRE : return {
      ...state,
      loading: false,
      isDeleteUserSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
